import { render } from "./OscarPoolBallotPage.vue?vue&type=template&id=f51853fe&scoped=true"
import script from "./OscarPoolBallotPage.vue?vue&type=script&lang=js"
export * from "./OscarPoolBallotPage.vue?vue&type=script&lang=js"

import "./OscarPoolBallotPage.vue?vue&type=style&index=0&id=f51853fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51853fe"]])

export default __exports__